import styled, { CSSProperties } from 'styled-components';

const DebugOnly = ({ style, children }: { style?: CSSProperties; children: React.ReactNode }) => {
  return process.env.NODE_ENV === 'development' ? <BackgroundTextDiv style={style}>{children}</BackgroundTextDiv> : null;
};

const BackgroundTextDiv = styled.div`
  background-color: #f0f0f0;
  opacity: 0.5;
`;

export default DebugOnly;
